import React, { useEffect, useState } from 'react'
import './styles.scss'
import { groups } from 'd3-array'
import Chart from 'components/Charts_Chart'
import { formatSwissDate } from 'components/Charts_Assets'
import Key from 'components/Charts_Key'
import { scaleLinear } from 'd3-scale'
type drawDataType = {
  covid: number
  d: string
  name: string
  noncovid: number
  total: number
  used: number
}[]

const sortSave = (a, b) =>
  (b[1][b[1].length - 1].covid * 100) / b[1][b[1].length - 1].total -
    (a[1][a[1].length - 1].covid * 100) / a[1][a[1].length - 1].total ||
  b[1][b[1].length - 1].total - a[1][a[1].length - 1].total

export const Hospitals = () => {
  const [drawData, setDrawData] = useState<
    [string, drawDataType][] | undefined
  >()
  const [vaccData, setVaccData] = useState<any | undefined>()

  useEffect(() => {
    fetch(
      'https://ta-interaktiv.storage.googleapis.com/corona-dashboard/ZH-Hospitals.json'
    )
      .then(response => response.json())
      .then(data => {
        let dd = (groups(data, d => d.name) as [string, drawDataType][]).sort(
          (a, b) =>
            ((b[1][b[1].length - 1].covid + b[1][b[1].length - 1].noncovid) *
              100) /
              b[1][b[1].length - 1].used -
              ((a[1][a[1].length - 1].covid + a[1][a[1].length - 1].noncovid) *
                100) /
                a[1][a[1].length - 1].used ||
            b[1][b[1].length - 1].used - a[1][a[1].length - 1].used
        )
        let total = dd
          .map(m => m[1][m[1].length - 1])
          .reduce(
            (a, b) => {
              a.covid += b.covid
              a.noncovid += b.noncovid
              a.total += b.total
              a.used += b.used
              a.d = b.d
              return a
            },
            {
              covid: 0,
              noncovid: 0,
              total: 0,
              name: 'Alle Spitäler',
              d: '',
              used: 0
            }
          )
        dd.unshift(['Alle Spitäler', [total]])
        setDrawData(dd)
      })
  }, [])

  return (
    <Chart
      title='Auslastung der Intensivstationen nach Spital'
      sub={
        drawData
          ? 'bis ' +
            formatSwissDate(
              drawData[drawData.length - 1][1][
                drawData[drawData.length - 1][1].length - 1
              ].d
            )
          : undefined
      }
      source={
        <>
          Quelle:{' '}
          <a
            href='https://raw.githubusercontent.com/openZH/covid_19/master/fallzahlen_kanton_zh/COVID19_Belegung_Intensivpflege.csv'
            target='_blank'
          >
            Gesundheitsdirektion Kanton Zürich
          </a>
        </>
      }
    >
      <div className='Hospitals'>
        {!drawData && <>Daten werden geladen...</>}

        {drawData && (
          <>
            <Key
              entries={[
                {
                  type: 'shape',
                  label: ' Auslastung mit Covid-19-Patienten',
                  color: '#d3343f'
                },
                {
                  type: 'shape',
                  label: 'Auslastung mit nicht Covid-19-Patienten',
                  color: '#6F7187'
                },
                {
                  type: 'shape',
                  label: 'Nicht belegte IPS-Betten',
                  color: '#9bc6de'
                },
                {
                  type: 'shape-pattern',
                  label: 'Nicht betriebene IPS-Betten',
                  color: '#9bc6de'
                }
              ]}
            />

            <div className='tablekey'><span>Auslastung der betriebenen Betten</span></div>
            {drawData.map(([name, data], i) => {
              const { covid, noncovid, total, used } = data[data.length - 1]
              const occupied = noncovid + covid
              const maxForUsed = 100
              const percent = scaleLinear()
                .domain([0, 150])
                .range([0, 100])
              const rel = {
                total: +(((total - used) * maxForUsed) / used).toFixed(1),
                covid: +((covid * maxForUsed) / used).toFixed(1),
                noncovid: +((noncovid * maxForUsed) / used).toFixed(1),
                occupied: +((occupied * maxForUsed) / used).toFixed(1),
                used: +(100 - ((used - total) * maxForUsed) / used).toFixed(1)
              }
              return (
                <div
                  className={'row' + (i === 0 ? ' first' : '')}
                  key={'Hospitals_' + i}
                >
                  <div className='label'>{name.replace('sS', 'ss')}</div>
                  <div className='utilization'>{rel.occupied.toFixed(0)}%</div>

                  <div className='bar'>
                    <div
                      className='total'
                      style={{
                        width: percent(rel.total) + '%',
                        left: percent(100) + '%'
                      }}
                    />
                     <div className='used' style={{ right: percent(50) + '%' }} />

                 <div
                      className='covid '
                      style={{ width: percent(rel.covid) + '%' }}
                    >
                      {rel.covid >= 20&& (
                        <div className='pad'>
                          {rel.covid.toFixed(0)}
                          {rel.covid > 20 ? '' : ''}%
                        </div>
                      )}
                    </div>
                    <div
                      className='noncovid'
                      style={{ width: percent(rel.noncovid) + '%' }}
                    >
                      {rel.noncovid >= 20 && (
                        <div className='pad'>
                          {rel.noncovid.toFixed(0)}
                          {rel.noncovid > 20 ? '' : ''}%
                        </div>
                      )}
                    </div> 
                  </div>


                  {window.innerWidth > 600 && (
                    <div className='bedcount '>
                      <b>{occupied}</b> von {used} betriebenen Betten belegt
                      {covid > 0 && (
                        <>
                          , <b>{covid}</b> mit Covid-19
                        </>
                      )}
                    </div>
                  )}
                </div>
              )
            })}
          </>
        )}
      </div>{' '}
    </Chart>
  )
}
